import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../config/i18n';

class Select extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    style: PropTypes.object,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
  };

  static defaultProps = {
    id: undefined,
    required: false,
    style: {},
    name: '',
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    onChange.call(this, e.target.value);
  };

  render() {
    const {
      data,
      className,
      style,
      value,
      id,
      name,
      required,
    } = this.props;
    const options = data.map(o => (
      <option key={o.id} value={o.id}>{o.name}</option>
    ));

    return (
      <select
        className={className}
        style={style}
        onChange={this.handleChange}
        value={value}
        id={id}
        name={name}
        ref={(ref) => { this.select = ref; }}
        required={required}
      >
        <option value="">-- {i18n.t('select')} --</option>
        {options}
      </select>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/shared/Select.js